/**
 * Shared ability checks for router guards and layout (mirrors usePermissions composable).
 */
export function userHasRole (user, role) {
  const roles = user?.roles || []
  return roles.includes(role)
}

export function userHasAbility (user, ability) {
  if (!ability) return true
  if (userHasRole(user, 'owner')) return true
  const abilities = user?.abilities || []
  return abilities.includes('*') || abilities.includes(ability)
}

export function userHasAnyAbility (user, abilityList) {
  if (!Array.isArray(abilityList) || abilityList.length === 0) return true
  return abilityList.some(a => userHasAbility(user, a))
}
